import React from 'react';

export default props => (
  <svg viewBox={props.viewBox || '0 0 25 25'} style={{ display: 'block', margin: '0 auto' }}>
    <g fill={props.color}>
      <path d="M25,9.55l-9.55,0L12.5,0L9.55,9.55L0,9.55l7.72,5.9L4.77,25l7.73-5.9l7.73,5.9 l-2.95-9.55L25,9.55z M17.41,20.96l-4.91-3.75l-4.91,3.75l1.88-6.07l-5.03-3.84l6.22,0l1.84-5.97l1.84,5.97l6.22,0l-5.03,3.84 L17.41,20.96z" />
    </g>
  </svg>
);
